// Extract a friendly string from any axios error response.
// Backend can return `detail` as a string OR a dict like {code, message}.
// Passing a dict directly to toast.error renders nothing (silent failure),
// which is what caused the "Send to client" button to appear dead.
export const getApiErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  // FastAPI 422 validation errors: detail is an array of {loc, msg, ...} objects.
  if (Array.isArray(detail)) {
    const first = detail.find((d) => typeof d?.msg === 'string' && d.msg.trim());
    if (first) {
      const field = Array.isArray(first.loc) ? first.loc[first.loc.length - 1] : null;
      return field && typeof field === 'string' ? `${field}: ${first.msg}` : first.msg;
    }
    return fallback;
  }
  if (detail && typeof detail === 'object') {
    if (typeof detail.message === 'string' && detail.message.trim()) return detail.message;
  }
  if (typeof error?.message === 'string' && error.message.trim() && error.message !== 'Network Error') {
    return error.message;
  }
  return fallback;
};

export const getApiErrorCode = (error) => {
  const detail = error?.response?.data?.detail;
  if (detail && typeof detail === 'object' && typeof detail.code === 'string') return detail.code;
  return null;
};

export const isEmailNotVerifiedError = (error) =>
  error?.response?.status === 403 && getApiErrorCode(error) === 'email_not_verified';
